<template>
    <div class="user-logout-timer">

        <b-modal ref="logout-modal"
                 hide-footer
                 title="Auto Logout">
            <p>
                {{ $i18n.gt('LABEL_LOGOUT_WARNING') }} {{ countdown }} {{ $i18n.gt('LABEL_LOGOUT_WARNING_2') }}
            </p>
            <p>
                {{ $i18n.gt('LABEL_LOGOUT_CANCEL_MESSAGE') }}
            </p>
        </b-modal>

    </div>
</template>

<script>
    import Vue from 'vue'
    import IdleVue from 'idle-vue'

    /**
     * Component to automatically log the user out after a specified time interval
     */
    const TIMER_DELAY = 30 * 60
    const COUNTDOWN_LENGTH = 30

    const eventsHub = new Vue()
    Vue.use(IdleVue, {
        eventEmitter: eventsHub,
        idleTime: TIMER_DELAY * 1000
    })

    export default Vue.extend({
        name: "UserLogoutTimer",
        data() {
            return {
                countdown: null,
            }
        },
        onIdle() {
            // if there is a uuid stored on this device, it means they are using the iOS app
            // (or we are simulating that in the browser) - so don't log them out, as this will kill
            // the healthkit update loop
            let uuid = localStorage.getItem('uuid')
            if (this.$user.userId() && !uuid) {
                this.$refs['logout-modal'].show()
                this.startCountdown()
            }
        },
        onActive() {
            this.$refs['logout-modal'].hide()
        },
        methods: {
            startCountdown() {
                this.countdown = COUNTDOWN_LENGTH
                const interval = setInterval(() => {
                    this.countdown--

                    // time's up
                    if (this.countdown <= 0) {
                        clearInterval(interval)
                        this.$refs['logout-modal'].hide()
                        this.$user.logoutUser()
                    }
                }, 1000)
            }
        },
    })
</script>

